
export default {
  name: "elasticHeader",
  methods: {
    async selectFilter(value, key) {
      let inc = (((value||{}).value||'').split('+')||[]).reduce((acc,_)=>{
        if(_){
          let k = _.split('=')[0];
          let v = _.split('=')[1];
          acc[k]=v;
        }
        return acc;
      },{});
      if(!inc.orderby && key != 'limit'){
        return;
      }
      if(this.$store.getters.filters.orderby != inc.orderby){
        this.$store.getters.filters.page = 1;
      }else{
      }
      this.$store.commit("filters", {
        ...this.$store.getters.filters,
        orderby: inc.orderby,
        order: inc.order,
        sorting:key != 'limit'?value:this.$store.getters.filters.sorting,
        limit:key == 'limit'?value:this.$store.getters.filters.limit
      });
      let t = this.$hyperUtility.urlElasticCreator();
      if(process.browser){
        location.href=t;
      }else{
        this.$router.push(t);
      }
      // this.$store.dispatch('ajaxElasticSearch',{page:1,replace:true})
    },
  },
};
